var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('crud-facecade',{directives:[{name:"wechat-title",rawName:"v-wechat-title",value:(_vm.title),expression:"title"}],attrs:{"url":_vm.url,"columns":_vm.columnList,"buttons":_vm.buttons,"tableHeight":_vm.tableHeight,"addButton":{ permission: 'drug_way:create' },"updateButton":{ permission: 'drug_way:update' }}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26552f2b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dictionary/Drug/DrugWay.vue
// module id = null
// module chunks = 